/** Portada + galería sin duplicar rutas. */
export function getVacacionImagePaths(sede) {
  const paths = [];
  if (sede?.imagen) paths.push(sede.imagen);
  const gallery = Array.isArray(sede?.galeria) ? sede.galeria : [];
  for (const p of gallery) {
    if (typeof p === 'string' && p && !paths.includes(p)) paths.push(p);
  }
  return paths;
}
